/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import AnalyticsLogic from 'state/logic/AnalyticsLogic';
import AssetAllocationLogic from 'state/logic/AssetAllocationLogic';
import BusinessEventLogic from './BusinessEventLogic';
import FailedApiLogic from './FailedApiLogic';
import FailedUpdateViewAccessLogic from 'state/logic/FailedUpdateViewAccessLogic';
import FailedUpdatePreferencesLogic from './FailedUpdatePreferencesLogic';
import FailedUpdateContactInformationLogic from './FailedUpdateContactInfoLogic';
import FailedUpdateSubscriptionsLogic from 'state/logic/FailedUpdateSubscriptionLogic';
import FailedUpdateDividendCapitalGainLogic from './FailedUpdateDividendCapitalGainLogic';
import FailedUpdateBankAssociationsLogic from './FailedUpdateBankAssociationsLogic';
import FailedUpdateAlertsAndNotificationsLogic from './FailedUpdateAlertsAndNotificationsLogic';
import FailedUpdateBeneficiariesLogic from './FailedUpdateBeneficiariesLogic';
import FailedUpdateDocumentDeliveryLogic from './FailedUpdateDocumentDeliveryLogic';
import FailedAccountVisibilityLogic from './FailedAccountVisibilityLogic';
import FailedUpdateCustomAccountGroupsLogic from './FailedUpdateCustomAccountGroupsLogic';
import UpdateDocumentDeliveryLogic from './UpdateDocumentDeliveryLogic';
import UpdateBeneficiariesLogic from './UpdateBeneficiariesLogic';
import UpdateDividendCapitalGainLogic from './UpdateDividendCapitalGainLogic';
import UpdatePreferencesLogic from './UpdatePreferencesLogic';
import UpdateComplianceSubscriptionLogic from './UpdateComplianceSubscriptionLogic';
import UpdateSubscriptionsLogic from './UpdateSubscriptionsLogic';
import UpdateViewAccessLogic from 'state/logic/UpdateViewAccessLogic';
import UpdateWorkspacePreferencesLogic from './UpdateWorkspacePreferencesLogic';
import UpdateAlertsAndNotificationsLogic from './UpdateAlertsAndNotificationsLogic';
import ChallengeDepositsLogic from './ChallengeDepositsLogic';
import FailedChallengeDepositsLogic from './FailedChallengeDepositsLogic';
import ActivatedForTextAlertsLogic from './ActivatedForTextAlertsLogic';
import FailedActivatedForTextAlertsLogic from './FailedActivatedForTextAlertsLogic';
import SMSActivationCodeLogic from './SMSActivationCodeLogic';
import FailedSMSActivationCodeLogic from './FailedSMSActivationCodeLogic';
import IntradayRefreshLogic from './IntradayRefreshLogic';
import FailedIntradayRefreshLogic from './FailedIntradayRefreshLogic';
import FailedUpdateTrustedContactsLogic from './FailedUpdateTrustedContactsLogic';
import FailedUpdateCostBasisLogic from './FailedUpdateCostBasisLogic';
import UpdateMailingAddressLogic from 'state/logic/UpdateMailingAddressLogic';
import FailedUpdateMailingAddress from 'state/logic/FailedUpdateMailingAddress';
import FailedExchangeAccounts from './FailedExchangeAccounts';
import BeneficiariesV2Logic from './BeneficiariesV2Logic';
import FailedBeneficiariesV2Logic from './FailedBeneficiariesV2Logic';

export default [
  AnalyticsLogic,
  AssetAllocationLogic,
  BusinessEventLogic,
  FailedChallengeDepositsLogic,
  FailedApiLogic,
  FailedUpdatePreferencesLogic,
  FailedUpdateSubscriptionsLogic,
  FailedUpdateViewAccessLogic,
  FailedUpdateDividendCapitalGainLogic,
  FailedUpdateBankAssociationsLogic,
  FailedUpdateBeneficiariesLogic,
  FailedUpdateAlertsAndNotificationsLogic,
  FailedUpdateContactInformationLogic,
  FailedUpdateCustomAccountGroupsLogic,
  FailedUpdateTrustedContactsLogic,
  FailedUpdateDocumentDeliveryLogic,
  FailedActivatedForTextAlertsLogic,
  FailedSMSActivationCodeLogic,
  FailedIntradayRefreshLogic,
  FailedAccountVisibilityLogic,
  FailedUpdateCostBasisLogic,
  IntradayRefreshLogic,
  FailedExchangeAccounts,
  SMSActivationCodeLogic,
  ActivatedForTextAlertsLogic,
  ChallengeDepositsLogic,
  UpdateDocumentDeliveryLogic,
  UpdateBeneficiariesLogic,
  UpdatePreferencesLogic,
  UpdateDividendCapitalGainLogic,
  UpdateComplianceSubscriptionLogic,
  UpdateSubscriptionsLogic,
  UpdateViewAccessLogic,
  UpdateWorkspacePreferencesLogic,
  UpdateAlertsAndNotificationsLogic,
  UpdateMailingAddressLogic,
  FailedUpdateMailingAddress,
  BeneficiariesV2Logic,
  FailedBeneficiariesV2Logic
];
